// https://webpack.js.org/guides/public-path/#on-the-fly
__webpack_public_path__ = `${serverContextPath}/res/`; // NOSONAR

window.messages = require('./messages').default;

require('font-awesome/css/font-awesome.css');
require('marbes-iconfont/css/mif.scss');
require('mc/lib/commonInit');
